import React from "react";
import { useDispatch , useSelector} from "react-redux";

import { modifyDisplaymodal } from "../../state/redux";
import {  useUser} from "../../state/reactquery";

 

import croixclose from '../../images/croixclose.svg';


import './PopupWait.scss';


function PopupRadin(){
    const dispatch = useDispatch() ;
    const {data: user} = useUser(localStorage.getItem('token')) ;
      const compagniewait = useSelector(state=>state.formules.compagniewait) ;
    return(<div  className="containergray">
                <div  className="popupwait"  >
                <div className="modifcontratclose" ><img src={croixclose}  alt="imgclose" onClick={()=>{dispatch(modifyDisplaymodal(null))  }}  />       </div>

                        <div className="popupradin_texte center">{compagniewait} n’a pas encore n’a pas encore communiqué les identifiants de connexion pour {user.nom_courtier}. <br/>
                        Veuillez vous rapprocher de votre inspecteur pour accélérer la procédure.</div>

                    </div>
                </div>)
}

export default PopupRadin;

